const awards = [
  {
    name: "구글코리아",
    logo: "logo1.png",
    comment: "개개인이 최고의 역량을 낼 수 있도록 회사에서 물심양면으로 지원할 뿐만 아니라, 자율적으로 모두가 성실하게 일하는 기업문화",
  },
  {
    name: "데브시스터즈",
    logo: "logo3.png",
    comment: "모든 영광을 사내 식당에게 돌립니다.",
  },
  {
    name: "부산교통공사",
    logo: "logo8.png",
    comment: "부산의 자랑 부교공! 워라밸, 표현의 자유가 보장되는 수평적인 조직 문화, 원만한 노사관계",
  },
  {
    name: "비바리퍼블리카",
    logo: "logo4.png",
    comment: "회사의 전폭적 지원이 있고 손발척척 맞는 좋은 동료 정치없는 조직문화 투명한 정보공개 공정한 댓가 그에 기반한 자율과 책임 덕분.",
  },
  {
    name: "선데이토즈",
    logo: "logo6.png",
    comment: "워라밸이 좋고 수평적인 분위기. 좋은 동료들이 있는 곳!",
  },
  {
    name: "한국원자력연구원",
    logo: "logo7.png",
    comment: "원내 환경이 자유롭도록 모든 구성원이 노력하며 선진 복지문화를 거리낌 없이 수용하는 경영진의 노력",
  },
  {
    name: "한국HP",
    logo: "logo5.png",
    comment: "권위의식 허례허식 없고 합리적이고 상식적인 문화",
  },
  {
    name: "SAP코리아",
    logo: "logo10.png",
    comment: "최신의 기술, 뛰어난 사람들, 자유로운 환경이 수평적인 기업문화와 자연스럽게 결합되어 있는 회사. 직원들의 지속적인 성장기회까지!",
  },
  {
    name: "SK이노베이션",
    logo: "logo2.png",
    comment: "워라밸, 행복에 대한 다각적 고민, 구성원들을 위한 복지 혜택, 수평적인 문화",
  },
  {
    name: "SK텔레콤",
    logo: "logo9.png",
    comment: "구성원들의 자율을 중요시하는 회사. 노동조합에서도 구성원들의 행복을 위해 좋은 제도를 도입하고 있다.",
  },
];

export default awards;
